import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';
import { EventDetails } from '../../models/event';
import { TelemetryServices } from 'src/app/core/services/telemetry.service';

@Component({
  selector: 'app-event-tabs',
  templateUrl: './event-tabs.component.html',
  styleUrls: ['./event-tabs.component.scss'],
  standalone: false,
})
export class EventTabsComponent implements OnInit, OnChanges, OnDestroy {
  @Output() eventSel = new EventEmitter();
  @Input() eventData: EventDetails[] = [];
  noEvents: boolean = false;
  bckLateral: any;
  data = {
    // Required
    type: 'event-tabs component', //Required. Impression type (list, detail, view, edit, workflow, search)
    subtype: '', //Optional. Additional subtype. "Paginate", "Scroll"
    pageid: '', //Required.  Unique page id
    itype: '', // type of interaction - SWIPE, SCRUB (fast forward using page thumbnails) or AUTO
    stageto: '', // game level, stage of page id to which the navigation was done
  };

  selectedIndex: any;
  // allTabFlag:boolean = false;

  constructor(private _telemetryServices: TelemetryServices) {}

  ngOnInit() {
    this.bckLateral = localStorage.getItem('latScr');
    if (this.bckLateral == 'true') {
      const idx1 = +localStorage.getItem('evIndx');
      this.selectedIndex = idx1;
      localStorage.removeItem('evIndx');
    } else {
      this.selectedIndex = 0;
    }
    console.log(this.eventData);
    if (!this.eventData) {
      this.noEvents = true;
    } else {
      this.noEvents = false;
    }
    // telemtry  API CALL and, send data

    this.data.subtype = 'event-tabs';
    this.data.itype = 'AUTO';
    this.data.stageto = 'event tabs loading';
    if (this.data) {
      this._telemetryServices.telemetryImpression(this.data);
    }
  }

  ngOnChanges() {
    console.log(this.eventData);
    if (!this.eventData) {
      this.noEvents = true;
    } else {
      this.noEvents = false;
    }
    // telemtry  API CALL and, send data

    this.data.subtype = 'event-tabs';
    this.data.itype = 'AUTO';
    this.data.stageto = 'event tabs loading';
    if (this.data) {
      this._telemetryServices.telemetryImpression(this.data);
    }
  }

  onTabChanged(event) {
    // this.allTabFlag = false;
    localStorage.setItem('evIndx', event.index);
    console.log(event.index);
    console.log(this.eventData[event.index]);
    // this.onAllSelect.emit(this.allTabFlag);
    this.eventSel.emit(this.eventData[event.index]);
  }
  ngOnDestroy() {
    // telemtry end call

    this.data.subtype = 'event-tabs cleanup stage/end of page';
    this.data.itype = 'AUTO';
    this.data.stageto = 'destroy component,initial page';
    if (this.data) {
      this._telemetryServices.telemetryEnd(this.data);
    }
  }

  // selectedAll(){
  //   this.allTabFlag = true;
  //   this.onAllSelect.emit(this.allTabFlag)
  // }
}
